import { getRailsClient } from "../client";
import { Assessment, Question, QuizSubmissionRequest } from "./types/quizTypes";
import { AttemptsCount } from "./types/tournamentTypes";

interface TournamentRetakeQuizResponse {
  assessment: Assessment;
  question: Question;
  maxPoints: number;
  attemptsCount: AttemptsCount[];
  questionsData: Question[];
}

export const trackTournamentTimeIncrement = async ({
  contentType,
  contentId,
  seconds,
}: {
  contentType: "Lesson" | "Experiment";
  contentId: number;
  seconds: number;
}): Promise<{ seconds: number }> => {
  const client = getRailsClient();
  const url = `/api/internal_api/v2/tournament_contents/${contentId}/track_activity`;
  const { data } = await client.post(url, {
    event_name: "time_increment",
    seconds,
    type: contentType.toLowerCase(),
  });

  return data;
};

export const trackTournamentHintUse = async ({
  contentType,
  contentId,
  hintId,
}: {
  contentType: "Lesson" | "Experiment";
  contentId: number;
  hintId: number;
}): Promise<{ seconds: number }> => {
  const client = getRailsClient();
  const url = `/api/internal_api/v2/tournament_contents/${contentId}/track_activity`;
  const { data } = await client.post(url, {
    eventName: "hint_used",
    hintId,
    type: contentType.toLowerCase(),
  });

  return data;
};

export const tournamentRetakeQuiz = async ({
  contentId,
}: {
  contentId: number;
}): Promise<TournamentRetakeQuizResponse> => {
  const client = getRailsClient();
  const url = `/api/internal_api/v2/tournament_contents/${contentId}/lesson_restart_assessment`;
  const { data } = await client.post(url);

  return data;
};

export const submitTournamentQuizQuestion = async ({
  slug,
  questionId,
}: {
  slug: string;
  questionId: string;
}) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v2/tournament_assessment_questions/${questionId}`;
    const { data } = await client.put(API, {
      assessmentQuestion: {
        slug: slug,
      },
    });
    return data;
  } catch (error) {
    console.error("Error submitting quiz question:", error);
    throw error;
  }
};

export const submitTournamentQuiz = async (quiz: QuizSubmissionRequest) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v2/tournament_assessment_questions/submit`;
    const { data } = await client.put(API, {
      assessment: quiz,
    });
    return data;
  } catch (error) {
    console.error(`Error submitting quiz for assessment ${quiz.assessmentId}:`, error);
    throw error;
  }
};
